import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { Header } from "./components/Header";
import toast, { Toaster } from "react-hot-toast";
import { ShimmerTable } from "react-shimmer-effects";
import Navbar from "./components/Navbar";

const API_URL = "/api";

export default function Details() {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companyID, setCompanyID] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [yearOfFunded, setYearOfFunded] = useState(null);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [banks, setBanks] = useState({});
  const [isTransaction, setIsTransaction] = useState(false);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getComapnyProfile/${id}`);
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setCompany(data);
        setCompanyID(data?.COMPANYID);
        const comId = data?.COMPANYID;
        console.log("Data", data);
        setYearOfFunded(data?.COMPANYINFO?.YEARFOUNDED);
        console.log("Year", yearOfFunded);
        setFormData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyDetails();
  }, [id]);

  useEffect(() => {
    if (company?.COMPANYINFO?.COMPANYNAME_ENGLISH) {
      document.title = company.COMPANYINFO.COMPANYNAME_ENGLISH;
    } else {
      document.title = "Company Log"; // fallback
    }
    // calling 2nd API to check transaction

    const fetchTransaction = async () => {
      try {
        const response = await fetch(
          `${API_URL}/isTransactionDetailsByCompanyId/${companyID}`
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        console.log("Transaction Data", data);
        setIsTransaction(data);
        console.log("Transaction", isTransaction);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTransaction();

    return () => {
      document.title = "Company Log";
    };
  }, [company]);

  useEffect(() => {
    axios
      .get("http://localhost:8000/riverchain/techop/v1.1/getBankcodes")
      .then((res) => {
        console.log("Bank API response:", res.data);

        const bankMap = {};
        res.data.forEach((bank) => {
          const name = bank["Bank Name"];
          const code = bank["Bank Code"];
          const swift = bank["Swift Code"];

          if (name) {
            bankMap[name] = {
              bankCode: code || "",
              swiftCode: swift || "",
            };
          }
        });

        setBanks(bankMap);
      })
      .catch((err) => console.error("Error fetching banks:", err));
  }, []);

  function formatDate(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  function formatDateMM(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A"; // Handle invalid date
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  const formatUSCurrency = (value) => {
    if (typeof value !== "number") return "0.00";
    return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const reviewedby = ["Kiril Popov", "Swati Jaiswal", "Shermaine Tan"];
  const placeOfIncorporationOptions = ["Hong Kong", "Singapore", "Thailand"];
  const categoryOptions = [
    "Subcontractor",
    "Main Contractor",
    "Supplier",
    "Other",
  ];
  const Confirmation = ["Confirmed", "Not Confirmed"];
  const handleChange = (path, value) => {
    const keys = path.split(".");
    setFormData((prev) => {
      const updated = { ...prev };
      let current = updated;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      return updated;
    });
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const payload = {
        COMPANYID: company.COMPANYID,
        update_data: formData,
      };

      const response = await fetch(
        `${API_URL}/updateCompanyProfile?username=pritomrajkhowa`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Failed to update company profile");

      const result = await response.json();
      toast.success("Company profile updated successfully");

      const updatedResponse = await fetch(`${API_URL}/getComapnyProfile/${id}`);
      const updatedData = await updatedResponse.json();
      setCompany(updatedData);
      setFormData(updatedData);
      setIsEditing(false);
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update company profile");
    } finally {
      setIsSubmitting(false);
    }
  };

  // const renderValue = (label, path, formatter) => {
  //   const getValueFromPath = (path) => {
  //     if (typeof path !== "string") return null;
  //     const keys = path.split(".");
  //     let val = formData;

  //     for (const key of keys) {
  //       const arrayMatch = key.match(/(\w+)\[(\d+)\]/);
  //       if (arrayMatch) {
  //         const [, arrKey, index] = arrayMatch;
  //         val = val?.[arrKey]?.[parseInt(index)];
  //       } else {
  //         val = val?.[key];
  //       }
  //     }

  //     return val;
  //   };

  //   const rawValue = getValueFromPath(path);
  //   const value =
  //     typeof formatter === "function" ? formatter(rawValue) : rawValue;

  //   let backgroundColor = "#fdf3d0";
  //   let color = "inherit";

  //   if (path === "PRIMARYACCOUNT.Confirmation") {
  //     if (rawValue === "Confirmed") {
  //       backgroundColor = "lightgreen";
  //       color = "white";
  //     } else if (rawValue === "Not Confirmed") {
  //       backgroundColor = "white";
  //       color = "blue";
  //     }
  //   }

  //   return (
  //     <tr>
  //       <td style={{ width: "50%" }}>{label}</td>
  //       <td
  //         style={{
  //           width: "50%",
  //           backgroundColor,
  //           color,
  //           textAlign: "center",
  //         }}
  //       >
  //         {isEditing ? (
  //           <input
  //             type="text"
  //             className="form-control"
  //             value={rawValue || ""}
  //             onChange={(e) => handleChange(path, e.target.value)}
  //           />
  //         ) : (
  //           value ?? ""
  //         )}
  //       </td>
  //     </tr>
  //   );
  // };

  // const renderValue = (label, path, formatter) => {
  //   // Get value from a nested path like "SHAREHOLDERS[0].NAME"
  //   const getValueFromPath = (path) => {
  //     if (!path) return null;
  //     const keys = path.split(".");
  //     let val = formData;
  //     for (const key of keys) {
  //       const arrayMatch = key.match(/(\w+)\[(\d+)\]/);
  //       if (arrayMatch) {
  //         const [, arrKey, index] = arrayMatch;
  //         val = val?.[arrKey]?.[parseInt(index, 10)];
  //       } else {
  //         val = val?.[key];
  //       }
  //     }
  //     return val;
  //   };

  //   // Set value in formData immutably
  //   const setValueAtPath = (path, newValue) => {
  //     setFormData((prev) => {
  //       const keys = path.split(".");
  //       const updated = structuredClone(prev); // deep copy
  //       let obj = updated;
  //       for (let i = 0; i < keys.length - 1; i++) {
  //         const arrayMatch = keys[i].match(/(\w+)\[(\d+)\]/);
  //         if (arrayMatch) {
  //           const [, arrKey, index] = arrayMatch;
  //           obj[arrKey] = obj[arrKey] || [];
  //           obj = obj[arrKey][parseInt(index, 10)] =
  //             obj[arrKey][parseInt(index, 10)] || {};
  //         } else {
  //           obj[keys[i]] = obj[keys[i]] || {};
  //           obj = obj[keys[i]];
  //         }
  //       }
  //       const lastKey = keys[keys.length - 1];
  //       const lastArrayMatch = lastKey.match(/(\w+)\[(\d+)\]/);
  //       if (lastArrayMatch) {
  //         const [, arrKey, index] = lastArrayMatch;
  //         obj[arrKey][parseInt(index, 10)] = newValue;
  //       } else {
  //         obj[lastKey] = newValue;
  //       }
  //       return updated;
  //     });
  //   };

  //   const rawValue = getValueFromPath(path);
  //   const displayValue =
  //     typeof formatter === "function" ? formatter(rawValue) : rawValue ?? "";

  //   let backgroundColor = "#fdf3d0";
  //   let color = "inherit";

  //   if (path === "PRIMARYACCOUNT.Confirmation") {
  //     if (rawValue === "Confirmed") {
  //       backgroundColor = "lightgreen";
  //       color = "white";
  //     } else if (rawValue === "Not Confirmed") {
  //       backgroundColor = "white";
  //       color = "blue";
  //     }
  //   }

  //   return (
  //     <tr>
  //       <td style={{ width: "50%" }}>{label}</td>
  //       <td
  //         style={{
  //           width: "50%",
  //           backgroundColor,
  //           color,
  //           textAlign: "center",
  //         }}
  //       >
  //         {isEditing ? (
  //           <input
  //             type="text"
  //             className="form-control"
  //             value={rawValue ?? ""}
  //             onChange={(e) => setValueAtPath(path, e.target.value)}
  //           />
  //         ) : (
  //           displayValue
  //         )}
  //       </td>
  //     </tr>
  //   );
  // };

  // const renderValue = (label, paths, formatter, cellStyle = {}) => {
  //   const getValueFromPath = (path) => {
  //     const keys = path.split(".");
  //     let val = formData;
  //     for (const key of keys) {
  //       const match = key.match(/(\w+)\[(\d+)\]/);
  //       if (match) {
  //         const [, arrKey, index] = match;
  //         val = val?.[arrKey]?.[parseInt(index)];
  //       } else {
  //         val = val?.[key];
  //       }
  //     }
  //     // Return undefined for truly missing values (not 0)
  //     return val === undefined ? undefined : val;
  //   };

  //   const updateValueAtPath = (path, newValue) => {
  //     setFormData((prev) => {
  //       const updated = { ...prev };
  //       let ref = updated;
  //       const keys = path.split(".");
  //       for (let i = 0; i < keys.length - 1; i++) {
  //         const match = keys[i].match(/(\w+)\[(\d+)\]/);
  //         if (match) {
  //           const [, arrKey, index] = match;
  //           ref[arrKey] = [...(ref[arrKey] || [])];
  //           ref = ref[arrKey];
  //           if (!ref[index]) ref[index] = {};
  //           ref = ref[index];
  //         } else {
  //           ref[keys[i]] = { ...(ref[keys[i]] || {}) };
  //           ref = ref[keys[i]];
  //         }
  //       }
  //       const lastKey = keys[keys.length - 1];
  //       const lastMatch = lastKey.match(/(\w+)\[(\d+)\]/);
  //       if (lastMatch) {
  //         const [, arrKey, index] = lastMatch;
  //         ref[arrKey] = [...(ref[arrKey] || [])];
  //         ref[arrKey][index] = newValue;
  //       } else {
  //         ref[lastKey] = newValue;
  //       }
  //       return updated;
  //     });
  //   };

  //   if (!Array.isArray(paths)) {
  //     paths = [paths];
  //   }

  //   let values = paths.map(getValueFromPath);

  //   // Auto background for OWNERSHIPPERCENTAGE
  //   const autoCellStyle = {};
  //   if (paths.includes("PRIMARYACCOUNT.Confirmation")) {
  //     const confirmationValue = values[0];
  //     if (confirmationValue === "Confirmed") {
  //       cellStyle = { backgroundColor: "green", color: "white" };
  //     } else if (confirmationValue === "Not confirmed") {
  //       cellStyle = { backgroundColor: "white", color: "blue" };
  //     }
  //   }

  //   return (
  //     <tr>
  //       <td style={{ width: "50%" }}>{label}</td>
  //       <td
  //         style={{
  //           width: "50%",
  //           textAlign: "center",
  //           ...autoCellStyle,
  //           ...cellStyle,
  //         }}
  //       >
  //         {isEditing
  //           ? paths.map((path, idx) => (
  //               <input
  //                 key={idx}
  //                 type="text"
  //                 className="form-control mb-1"
  //                 value={values[idx] ?? ""}
  //                 onChange={(e) => updateValueAtPath(path, e.target.value)}
  //               />
  //             ))
  //           : typeof formatter === "function"
  //           ? // If undefined or null, show nothing
  //             values[0] === undefined || values[0] === null
  //             ? ""
  //             : formatter(values.length === 1 ? values[0] : values)
  //           : values.filter((v) => v !== undefined && v !== null).join(" / ")}
  //       </td>
  //     </tr>
  //   );
  // };

  const renderValue = (label, paths, formatter, cellStyle = {}) => {
    const getValueFromPath = (path) => {
      const keys = path.split(".");
      let val = formData;
      for (const key of keys) {
        const match = key.match(/(\w+)\[(\d+)\]/);
        if (match) {
          const [, arrKey, index] = match;
          val = val?.[arrKey]?.[parseInt(index)];
        } else {
          val = val?.[key];
        }
      }
      return val === undefined ? undefined : val;
    };

    const updateValueAtPath = (path, newValue) => {
      setFormData((prev) => {
        const updated = { ...prev };
        let ref = updated;
        const keys = path.split(".");
        for (let i = 0; i < keys.length - 1; i++) {
          const match = keys[i].match(/(\w+)\[(\d+)\]/);
          if (match) {
            const [, arrKey, index] = match;
            ref[arrKey] = [...(ref[arrKey] || [])];
            ref = ref[arrKey];
            if (!ref[index]) ref[index] = {};
            ref = ref[index];
          } else {
            ref[keys[i]] = { ...(ref[keys[i]] || {}) };
            ref = ref[keys[i]];
          }
        }
        const lastKey = keys[keys.length - 1];
        const lastMatch = lastKey.match(/(\w+)\[(\d+)\]/);
        if (lastMatch) {
          const [, arrKey, index] = lastMatch;
          ref[arrKey] = [...(ref[arrKey] || [])];
          ref[arrKey][index] = newValue;
        } else {
          ref[lastKey] = newValue;
        }
        return updated;
      });
    };

    if (!Array.isArray(paths)) {
      paths = [paths];
    }

    let values = paths
      .map(getValueFromPath)
      .filter((v) => v !== undefined && v !== null)
      .flatMap((v) => (Array.isArray(v) ? v : [v]));

    // Auto background for Confirmation
    const autoCellStyle = {};
    if (paths.includes("PRIMARYACCOUNT.Confirmation")) {
      const confirmationValue = values[0];
      if (confirmationValue === "Confirmed") {
        cellStyle = { backgroundColor: "green", color: "white" };
      } else if (confirmationValue === "Not confirmed") {
        cellStyle = { backgroundColor: "white", color: "blue" };
      }
    }

    return (
      <tr>
        <td style={{ width: "50%" }}>{label}</td>
        <td
          style={{
            width: "50%",
            textAlign: "center",
            ...autoCellStyle,
            ...cellStyle,
          }}
        >
          {isEditing
            ? values.map((val, idx) => {
                const path = paths[0].toLowerCase();

                // detect field type
                const isDateField =
                  path.includes("date") ||
                  path.includes("period") ||
                  path.includes("yearfounded");
                const isReviewedBy = path.includes("reviewedby");
                const isPlaceOfIncorporation = path.includes(
                  "placeofincorporation"
                );
                const isCategory =
                  paths[0].toLowerCase() === "industry.category";
                const isBankName = path.includes("bankname");
                const isConfirmation =
                  paths[0].toLowerCase() === "primaryaccount.confirmation";

                let inputType = "text";
                let inputValue = val ?? "";

                if (isDateField) {
                  inputType = "date";
                  inputValue = val
                    ? new Date(val).toISOString().split("T")[0]
                    : "";
                }

                // Dropdown for "Reviewed by"
                if (isReviewedBy) {
                  const normalizedValue = (inputValue || "").trim();

                  // ensure DB value is included in dropdown
                  const allOptions = reviewedby.includes(normalizedValue)
                    ? reviewedby
                    : normalizedValue
                    ? [...reviewedby, normalizedValue]
                    : reviewedby;

                  return (
                    <select
                      key={idx}
                      className="form-control mb-1"
                      value={normalizedValue}
                      onChange={(e) =>
                        updateValueAtPath(paths[0], e.target.value)
                      }
                    >
                      <option value="">-- Select Reviewer --</option>
                      {allOptions.map((opt, i) => (
                        <option key={i} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  );
                }
                if (isPlaceOfIncorporation) {
                  const normalizedValue = (inputValue || "").trim();
                  const allOptions = placeOfIncorporationOptions.includes(
                    normalizedValue
                  )
                    ? placeOfIncorporationOptions
                    : normalizedValue
                    ? [...placeOfIncorporationOptions, normalizedValue]
                    : placeOfIncorporationOptions;

                  return (
                    <select
                      key={idx}
                      className="form-control mb-1"
                      value={normalizedValue}
                      onChange={(e) =>
                        updateValueAtPath(paths[0], e.target.value)
                      }
                    >
                      <option value="">
                        -- Select Place of Incorporation --
                      </option>
                      {allOptions.map((opt, i) => (
                        <option key={i} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  );
                }
                if (isCategory) {
                  const normalizedValue = (inputValue || "").trim();
                  const allOptions = categoryOptions.includes(normalizedValue)
                    ? categoryOptions
                    : normalizedValue
                    ? [...categoryOptions, normalizedValue]
                    : categoryOptions;

                  return (
                    <select
                      key={idx}
                      className="form-control mb-1"
                      value={normalizedValue}
                      onChange={(e) =>
                        updateValueAtPath(paths[0], e.target.value)
                      }
                    >
                      <option value="">-- Select Category --</option>
                      {allOptions.map((opt, i) => (
                        <option key={i} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  );
                }
                if (isBankName) {
                  const normalizedValue = (inputValue || "").trim();
                  const allOptions = Object.keys(banks);

                  return (
                    <select
                      key={idx}
                      className="form-control mb-1"
                      value={normalizedValue}
                      onChange={(e) => {
                        const selectedBank = e.target.value;
                        updateValueAtPath(paths[0], selectedBank);

                        // also auto-update Bank Code + Swift Code
                        if (banks[selectedBank]) {
                          updateValueAtPath(
                            "PRIMARYACCOUNT.bankCode",
                            banks[selectedBank].bankCode
                          );
                          updateValueAtPath(
                            "PRIMARYACCOUNT.swiftCode",
                            banks[selectedBank].swiftCode
                          );
                        }
                      }}
                    >
                      <option value="">-- Select Bank --</option>
                      {allOptions.map((opt, i) => (
                        <option key={i} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  );
                }
                if (isConfirmation) {
                  const normalizedValue = (inputValue || "").trim();
                  const allOptions = Confirmation.includes(normalizedValue)
                    ? Confirmation
                    : normalizedValue
                    ? [...Confirmation, normalizedValue]
                    : Confirmation;

                  return (
                    <select
                      key={idx}
                      className="form-control mb-1"
                      value={normalizedValue}
                      onChange={(e) =>
                        updateValueAtPath(paths[0], e.target.value)
                      }
                    >
                      <option value="">-- Select Category --</option>
                      {allOptions.map((opt, i) => (
                        <option key={i} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  );
                }

                // Default input
                return (
                  <input
                    key={idx}
                    type={inputType}
                    className="form-control mb-1"
                    value={inputValue}
                    onChange={(e) =>
                      updateValueAtPath(paths[0], e.target.value)
                    }
                  />
                );
              })
            : typeof formatter === "function"
            ? values.length === 0
              ? ""
              : formatter(values.length === 1 ? values[0] : values)
            : values.join(" / ")}
        </td>
      </tr>
    );
  };

  return (
    <div className="app-container">
      <Toaster />

      <div className="container-fluid">
        <div className="content">
          <div className="row">
            <Navbar />

            <div className="col-md-10" style={{ marginTop: "30px" }}>
              <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
                Back to Company Log
              </NavLink>

              <br />
              <br />

              <NavLink to={`/details/${id}`} className="btn btn-dark ms-2">
                Company Information
              </NavLink>

              <NavLink
                to={`/DocumentCheckList/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Document Checklist
              </NavLink>

              <NavLink
                to={`/Searches/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Searches
              </NavLink>

              <NavLink
                to={`/FinancialAnalysis/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Financial Analysis
              </NavLink>

              <NavLink
                to={`/CompanyScore/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Company Score
              </NavLink>
              <NavLink
                to={`/ScoringCriteria/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Scoring Criteria
              </NavLink>

              {isTransaction && (
                <NavLink
                  to={`/TransactionList/${id}`}
                  className="btn btn-outline-secondary ms-2"
                >
                  Transactions details
                </NavLink>
              )}

              {loading ? (
                <div className="mt-4">
                  <ShimmerTable row={5} col={2} />
                </div>
              ) : error ? (
                <div>Error: {error}</div>
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 style={{ marginTop: "10px" }}>
                      Company Information
                      <span
                        style={{
                          paddingLeft: "20px",
                          color: "red",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        {company?.VersionString}
                      </span>
                    </h3>
                    {!isEditing ? (
                      <button
                        className="btn btn-primary"
                        onClick={() => setIsEditing(true)}
                      >
                        Edit
                      </button>
                    ) : (
                      <div>
                        <button
                          className="btn btn-success me-2"
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={() => setIsEditing(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>

                  <p>
                    <b>Scorecard Details</b>
                  </p>
                  <table className="table table-bordered">
                    {renderValue(
                      "Scoring Performed by",
                      "ReviewByData.SCORINGPERFORMEDBY",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue("Date", "ReviewByData.DATE", formatDate, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue(
                      "Reviewed by",
                      "ReviewByData.REVIEWEDBY",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                    {renderValue(
                      "Date:",
                      "ReviewByData.DATE_REVIEW",
                      formatDate,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                  </table>

                  <p>
                    <b>Company Information</b>
                  </p>
                  <table className="table table-bordered">
                    {renderValue(
                      "Company Name (English):",
                      "COMPANYINFO.COMPANYNAME_ENGLISH",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue(
                      "Company Name (Chinese):",
                      "COMPANYINFO.COMPANYNAME_CHINESE",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {/* Conditional Fields */}
                    {formData.COMPANYINFO.PLACEOFINCORPORATION ===
                      "Hong Kong" && (
                      <>
                        {renderValue(
                          "Business Registration Number",
                          "COMPANYINFO.BUSINESSREGISTRATIONNUMBER"
                        )}
                      </>
                    )}

                    {formData.COMPANYINFO.PLACEOFINCORPORATION ===
                      "Singapore" && (
                      <>{renderValue("UEN", "COMPANYINFO.UEN")}</>
                    )}

                    {renderValue(
                      "Registered Address:",
                      "COMPANYINFO.REGISTEREDADDRESS",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue(
                      "Year Founded:",
                      "COMPANYINFO.YEARFOUNDED",
                      formatDateMM,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}

                    {renderValue("Industry:", "COMPANYINFO.INDUSTRY", null, {
                      backgroundColor: "#fdf3d0",
                    })}

                    {renderValue(
                      "Place of Incorporation:",
                      "COMPANYINFO.PLACEOFINCORPORATION",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue(
                      "Nature of Business:",
                      "NATUREOFBUSINESS",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                    {renderValue("Company Type:", "COMPANYTYPE", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("Category:", "INDUSTRY.CATEGORY", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("Subcategory:", "INDUSTRY.SUBCATEGORY", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                  </table>

                  <p>
                    <b>Shareholder capital</b>
                  </p>
                  <table className="table table-bordered">
                    {renderValue(
                      "Shareholder capital value (HKD):",
                      "OWNERSHIPSTRUCTURE.SHAREHOLDERCAPITALVALUE_HKD",
                      formatUSCurrency,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue(
                      "Period:",
                      "OWNERSHIPSTRUCTURE.PERIOD",
                      formatDate,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                  </table>

                  <p>
                    <b>Ownership</b>
                  </p>
                  <table className="table table-bordered">
                    {renderValue(
                      "Shareholder 1:",
                      "SHAREHOLDERS[0].NAME",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}

                    {renderValue(
                      "Shareholder 1 ownership %:",
                      "SHAREHOLDERS[0].OWNERSHIPPERCENTAGE",
                      (v) => (v != null ? `${Math.round(v * 100)}%` : ""),
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {renderValue(
                      "Shareholder 2:",
                      "SHAREHOLDERS[1].NAME",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                    {renderValue(
                      "Shareholder 2 ownership %:",
                      "SHAREHOLDERS[1].OWNERSHIPPERCENTAGE",
                      (v) => {
                        if (v === null || v === undefined) {
                          return ""; // don't display anything
                        }
                        return `${Math.round(v * 100)}%`;
                      },
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {renderValue(
                      "Shareholder 3:",
                      "SHAREHOLDERS[2].NAME",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                    {renderValue(
                      "Shareholder 3 ownership %:",
                      "SHAREHOLDERS[2].OWNERSHIPPERCENTAGE",
                      (v) => (v != null ? `${Math.round(v * 100)}%` : ""),
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {renderValue("Director 1:", "DIRECTORS[0].NAME", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("Director 2:", "DIRECTORS[1].NAME", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("Director 3:", "DIRECTORS[2].NAME", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue(
                      "Other Authorized Signatory (if any):",
                      "",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                    {renderValue(
                      "Other Authorized Signatory (if any):",
                      "",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}
                  </table>

                  <p>
                    <b>Contact details</b>
                  </p>
                  <table className="table table-bordered">
                    {/* Primary Contact */}
                    {renderValue("Contact name:", "PRIMARYCONTACT.NAME", null, {
                      backgroundColor: "#fdf3d0",
                    })}

                    {renderValue(
                      "Contact phone number:",
                      [
                        "PRIMARYCONTACT.PHONENUMBER[0]",
                        "PRIMARYCONTACT.PHONENUMBER[1]",
                      ],
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {renderValue(
                      "Contact email address:",
                      "PRIMARYCONTACT.CONTACTEMAILADDRESS",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {/* Secondary Contact */}
                    {renderValue(
                      "Contact 2 name:",
                      "SECONDARYCONTACT.NAME",
                      null,
                      {
                        backgroundColor: "#fdf3d0",
                      }
                    )}

                    {renderValue(
                      "Contact 2 phone number:",
                      [
                        "SECONDARYCONTACT.PHONENUMBER[0]",
                        "SECONDARYCONTACT.PHONENUMBER[1]",
                      ],
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {renderValue(
                      "Contact 2 email address:",
                      "SECONDARYCONTACT.CONTACTEMAILADDRESS",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {/* Referred by */}
                    {renderValue(
                      "Referred by [name of third-party]:",
                      "REFERREDBY",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}

                    {/* Relationship Manager */}
                    {renderValue(
                      "Riverchain Relationship Manager:",
                      "PRIMARYCONTACT.RIVERCHAINRELATIONSHIPMANAGER",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                  </table>

                  <p>
                    <b>Bank Account Details</b>
                  </p>
                  <table className="table table-bordered">
                    {renderValue(
                      "Beneficiary Name",
                      "PRIMARYACCOUNT.beneficiaryName",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue(
                      "Bank Account Number",
                      "PRIMARYACCOUNT.bankAccountNumber",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                    {renderValue("Bank Name", "PRIMARYACCOUNT.bankName", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("Bank Code", "PRIMARYACCOUNT.bankCode", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue("SWIFT", "PRIMARYACCOUNT.swiftCode", null, {
                      backgroundColor: "#fdf3d0",
                    })}
                    {renderValue(
                      "Confirmation",
                      "PRIMARYACCOUNT.Confirmation",
                      null
                    )}
                    {renderValue(
                      "Date of Seller Payment Account Instruction",
                      "PRIMARYACCOUNT.accountInstructionDate",
                      null,
                      { backgroundColor: "#fdf3d0" }
                    )}
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
